/**
 * AppLivePreviewIframe bond setup
 *
 * Wires @molecule/app-live-preview-iframe to @molecule/app-live-preview
 */

import { setProvider } from '@molecule/app-live-preview'
import { provider } from '@molecule/app-live-preview-iframe'

export function setupAppLivePreviewIframe(): void {
  setProvider(provider)
}
